import { Button } from "@/components/elements/Button";
import { TopPage } from "@/components/elements/TopPage";
import { AppRoutes } from "@/routes/config";
import { black } from "@/theme/colors";
import { spacing } from "@/theme/variables";
import { Box, Container, Divider, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";

type TDashboardPageProps = {};

export const DashboardPage: FC<TDashboardPageProps> = () => {
  return (
    <Box>
      <TopPage title="ダッシュボード" enablePageBack={false} />
      <Container sx={{ minHeight: "70vh", display: "flex", alignItems: "center" }}>
        <Stack sx={{ width: "100%" }} direction="row" justifyContent="center" alignItems="flex-start">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="sub16Semi" sx={{ marginBottom: spacing["2xl"] }}>
              登録支援機関について作業する
            </Typography>

            <Button component={Link} variant="ghost" to={AppRoutes.rsoList}>
              登録支援機関トップページ
            </Button>
          </Box>

          <Divider
            orientation="vertical"
            flexItem
            sx={{
              borderColor: black[90],
              marginRight: "162px",
              marginLeft: "162px",
            }}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="sub16Semi" sx={{ marginBottom: spacing["2xl"] }}>
              自社支援について作業する
            </Typography>

            <Button component={Link} variant="ghost" to={AppRoutes.companyList}>
              自社支援トップページ
            </Button>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};
